import { Loader2 } from "lucide-react";
import { observer } from "mobx-react-lite";
import { useTran } from "@/hooks";
import { Badge } from "@/components/ui/badge";
import { useUserStore } from "../hooks";

const FollowUpCell = observer(({ user }) => {
  const { t } = useTran();
  const { followUpUserId, assignFollowUp, loadUsers } = useUserStore();
  const incharge = user?.incharge?.name;
  const followUpLoading = followUpUserId === user?.id;

  const handleFollowUp = async () => {
    if (!user?.id || followUpLoading) return;
    const result = await assignFollowUp(user.id);
    if (result !== null) {
      loadUsers();
    }
  };

  if (!incharge) {
    const handleKeyDown = (event) => {
      if (followUpLoading) return;
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        handleFollowUp();
      }
    };

    return (
      <Badge
        variant="outline"
        role="button"
        tabIndex={0}
        aria-disabled={followUpLoading}
        onClick={() => {
          if (!followUpLoading) {
            handleFollowUp();
          }
        }}
        onKeyDown={handleKeyDown}
        className={
          followUpLoading
            ? "bg-blue-50 text-blue-700 opacity-60"
            : "bg-blue-50 text-blue-700 cursor-pointer hover:bg-blue-100"
        }
      >
        {followUpLoading ? (
          <span className="inline-flex items-center gap-1" aria-live="polite">
            <Loader2 className="h-3 w-3 animate-spin" aria-hidden="true" />
            <span>{t("Follow Up")}</span>
          </span>
        ) : (
          t("Follow Up")
        )}
      </Badge>
    );
  }

  return (
    <Badge variant="outline" className="bg-emerald-50 text-emerald-700">
      {incharge}
    </Badge>
  );
});

export default FollowUpCell;
